// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23666%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}
.logs-header .search-container {
  flex: 1 1;
  min-width: 300px;
}

.filters-panel {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.filters-panel .filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}
.filters-panel .filters-header .filters-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  color: #212529;
}
.filters-panel .filters-header .filters-title svg {
  color: var(--m-primary, #007bff);
}
.filters-panel .filters-content {
  padding: 1.25rem;
}
.filters-panel .filters-content .filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}
.filters-panel .filters-content .filters-grid .filter-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.filters-panel .filters-content .filters-grid .filter-item .filter-select {
  width: 100%;
  padding: 0.625rem 0.875rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  color: #212529;
  transition: all 0.2s ease;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px;
  padding-right: 2.5rem;
}
.filters-panel .filters-content .filters-grid .filter-item .filter-select:hover {
  border-color: #cbd5e0;
  background-color: #f8f9fa;
}
.filters-panel .filters-content .filters-grid .filter-item .filter-select:focus {
  outline: none;
  border-color: var(--m-primary, #007bff);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  background-color: white;
}
.filters-panel .filters-content .filters-grid .filter-item .filter-select option {
  padding: 0.5rem;
}
.filters-panel .filters-content .filters-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.stats-panel {
  background: var(--m-primary);
  border-radius: 8px;
  margin-bottom: 1rem;
  color: white;
}
.stats-panel .stats-grid {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}
.stats-panel .stats-grid .stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.stats-panel .stats-grid .stat-item svg {
  color: white;
}
.stats-panel .stats-grid .stat-item span {
  font-size: 0.875rem;
  color: white;
}
.stats-panel .stats-grid .stat-item span strong {
  font-weight: 600;
}

.operation-cell strong {
  display: block;
  margin-bottom: 0.25rem;
  color: #212529;
}
.operation-cell .error-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.25rem;
  color: #dc3545;
  font-size: 0.75rem;
}
.operation-cell .error-badge span {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
}
.user-cell svg {
  flex-shrink: 0;
}

.time-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  white-space: nowrap;
}
.time-cell svg {
  flex-shrink: 0;
}

.error-row {
  background: rgba(220, 53, 69, 0.02) !important;
  border-left: 4px solid #dc3545;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.detail-section {
  margin-bottom: 2rem;
}
.detail-section h4 {
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #212529;
  border-bottom: 2px solid var(--m-primary);
  padding-bottom: 0.5rem;
}
.detail-section .detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}
.detail-section .detail-grid div {
  font-size: 0.875rem;
}
.detail-section .detail-grid div strong {
  display: block;
  margin-bottom: 0.25rem;
  color: #6c757d;
  font-size: 0.75rem;
  text-transform: uppercase;
}
.detail-section pre {
  background: #f5f5f5;
  padding: 1rem;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 0.75rem;
  line-height: 1.5;
  border: 1px solid #e0e0e0;
}
.detail-section .error-message {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  padding: 1rem;
  border-radius: 4px;
  border-left: 4px solid #dc3545;
  font-size: 0.875rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .logs-header {
    flex-direction: column;
    align-items: stretch;
  }
  .logs-header .search-container {
    width: 100%;
  }
  .filters-panel .filters-content {
    padding: 1rem;
  }
  .filters-panel .filters-content .filters-grid {
    grid-template-columns: 1fr !important;
    gap: 1rem;
  }
  .filters-panel .filters-content .filters-actions {
    padding-top: 0.75rem;
  }
  .detail-grid {
    grid-template-columns: 1fr !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Logs/Logs.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,gBAAA;AACJ;;AAGA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAAN;AAEM;EACE,gCAAA;AAAR;AAKE;EACE,gBAAA;AAHJ;AAKI;EACE,aAAA;EACA,2DAAA;EACA,YAAA;EACA,sBAAA;AAHN;AAKM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAHR;AAKQ;EACE,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;AAHV;AAKU;EACE,qBAAA;EACA,yBAAA;AAHZ;AAMU;EACE,aAAA;EACA,uCAAA;EACA,4CAAA;EACA,uBAAA;AAJZ;AAOU;EACE,eAAA;AALZ;AAWI;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;AATN;;AAcA;EACE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAXF;AAaE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAXJ;AAaI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAXN;AAaM;EACE,YAAA;AAXR;AAcM;EACE,mBAAA;EACA,YAAA;AAZR;AAcQ;EACE,gBAAA;AAZV;;AAoBE;EACE,cAAA;EACA,sBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBN;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AApBF;AAsBE;EACE,cAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AArBF;AAuBE;EACE,cAAA;AArBJ;;AAyBA;EACE,8CAAA;EACA,8BAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAtBF;AAwBE;EACE,gBAAA;EACA,eAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAvBF;AAyBE;EACE,kCAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,eAAA;AAxBJ;;AA4BA;EACE;IACE,uBAAA;EAzBF;EA2BA;IACE,yBAAA;EAzBF;AACF;AA4BA;EACE,mBAAA;AA1BF;AA4BE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;EACA,sBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AA3BJ;AA6BI;EACE,mBAAA;AA3BN;AA6BM;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AA3BR;AAgCE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA9BJ;AAiCE;EACE,kCAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAhCF;;AAmCA;EACE;IACE,sBAAA;IACA,oBAAA;EAhCF;EAkCE;IACE,WAAA;EAhCJ;EAqCE;IACE,aAAA;EAnCJ;EAqCI;IACE,qCAAA;IACA,SAAA;EAnCN;EAsCI;IACE,oBAAA;EApCN;EAyCA;IACE,qCAAA;EAvCF;AACF","sourcesContent":[".logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n  flex-wrap: wrap;\n\n  .search-container {\n    flex: 1;\n    min-width: 300px;\n  }\n}\n\n.filters-panel {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n\n  .filters-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #e0e0e0;\n    background: #f8f9fa;\n\n    .filters-title {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      font-weight: 600;\n      font-size: 0.9375rem;\n      color: #212529;\n\n      svg {\n        color: var(--m-primary, #007bff);\n      }\n    }\n  }\n\n  .filters-content {\n    padding: 1.25rem;\n\n    .filters-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n      gap: 1.25rem;\n      margin-bottom: 1.25rem;\n\n      .filter-item {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n\n        .filter-select {\n          width: 100%;\n          padding: 0.625rem 0.875rem;\n          border: 1px solid #e0e0e0;\n          border-radius: 6px;\n          font-size: 0.875rem;\n          background: white;\n          color: #212529;\n          transition: all 0.2s ease;\n          cursor: pointer;\n          appearance: none;\n          background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n          background-repeat: no-repeat;\n          background-position: right 0.75rem center;\n          background-size: 12px;\n          padding-right: 2.5rem;\n\n          &:hover {\n            border-color: #cbd5e0;\n            background-color: #f8f9fa;\n          }\n\n          &:focus {\n            outline: none;\n            border-color: var(--m-primary, #007bff);\n            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n            background-color: white;\n          }\n\n          option {\n            padding: 0.5rem;\n          }\n        }\n      }\n    }\n\n    .filters-actions {\n      display: flex;\n      justify-content: flex-end;\n      padding-top: 1rem;\n      border-top: 1px solid #e0e0e0;\n    }\n  }\n}\n\n.stats-panel {\n  background: var(--m-primary);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  color: white;\n\n  .stats-grid {\n    display: flex;\n    gap: 2rem;\n    flex-wrap: wrap;\n\n    .stat-item {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n\n      svg {\n        color: white;\n      }\n\n      span {\n        font-size: 0.875rem;\n        color: white;\n\n        strong {\n          font-weight: 600;\n        }\n      }\n    }\n  }\n}\n\n.operation-cell {\n  strong {\n    display: block;\n    margin-bottom: 0.25rem;\n    color: #212529;\n  }\n\n  .error-badge {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    margin-top: 0.25rem;\n    color: #dc3545;\n    font-size: 0.75rem;\n\n    span {\n      max-width: 300px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n\n.user-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #666;\n\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.time-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #666;\n  white-space: nowrap;\n\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.error-row {\n  background: rgba(220, 53, 69, 0.02) !important;\n  border-left: 4px solid #dc3545;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.detail-section {\n  margin-bottom: 2rem;\n\n  h4 {\n    margin-bottom: 1rem;\n    font-size: 1rem;\n    color: #212529;\n    border-bottom: 2px solid var(--m-primary);\n    padding-bottom: 0.5rem;\n  }\n\n  .detail-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    div {\n      font-size: 0.875rem;\n\n      strong {\n        display: block;\n        margin-bottom: 0.25rem;\n        color: #6c757d;\n        font-size: 0.75rem;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  pre {\n    background: #f5f5f5;\n    padding: 1rem;\n    border-radius: 4px;\n    overflow-x: auto;\n    font-size: 0.75rem;\n    line-height: 1.5;\n    border: 1px solid #e0e0e0;\n  }\n\n  .error-message {\n    background: rgba(220, 53, 69, 0.1);\n    color: #dc3545;\n    padding: 1rem;\n    border-radius: 4px;\n    border-left: 4px solid #dc3545;\n    font-size: 0.875rem;\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n  margin-top: 1rem;\n}\n\n@media (max-width: 768px) {\n  .logs-header {\n    flex-direction: column;\n    align-items: stretch;\n\n    .search-container {\n      width: 100%;\n    }\n  }\n\n  .filters-panel {\n    .filters-content {\n      padding: 1rem;\n\n      .filters-grid {\n        grid-template-columns: 1fr !important;\n        gap: 1rem;\n      }\n\n      .filters-actions {\n        padding-top: 0.75rem;\n      }\n    }\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
